import logo from '../assets/logo.png';
import { Button } from 'primereact/button';
import { useAppSelector } from '../hooks';

import { useHistory } from 'react-router';
import { useGetWorkspacesQuery } from '../workspaces/slice';

const NavbarLeft = () => {
    const history = useHistory();
    const workspace_slug = useAppSelector((state) => state.app.workspace_slug);
    const { data: workspaces } = useGetWorkspacesQuery();
    return <div className="left-part p-d-flex p-ai-center">
        <Button onClick={() => window.location.href = '/'} className="p-button-link">
            <img src={logo} alt="logo" />
        </Button>
        <Button onClick={() => history.push(`/workspace/${workspace_slug}`)} className="p-button-link">
            <div className="workspace_name">{workspaces?.results.find(w => w.slug === workspace_slug)?.name}</div>
        </Button>
    </div>;
}

export default NavbarLeft;
